import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { BooleanField } from "@/components/admin/boolean-field";

import { TopToolbar } from "../layout/TopToolbar";

const ProgramListActions = () => (
  <TopToolbar>
    <CreateButton label="resources.programs.action.new" />
  </TopToolbar>
);

export const ProgramList = () => (
  <List
    title={false}
    actions={<ProgramListActions />}
    sort={{ field: "starts_on", order: "DESC" }}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="name" />
      <DataTable.Col source="season" />
      <DataTable.Col source="starts_on">
        <DateField source="starts_on" />
      </DataTable.Col>
      <DataTable.Col source="ends_on">
        <DateField source="ends_on" />
      </DataTable.Col>
      <DataTable.Col source="active">
        <BooleanField source="active" />
      </DataTable.Col>
    </DataTable>
  </List>
);
